export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5290.56a667a5.jpg";